import { render, staticRenderFns } from "./LearningTest.vue?vue&type=template&id=a5ba3652&scoped=true&"
import script from "./LearningTest.vue?vue&type=script&lang=js&"
export * from "./LearningTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ba3652",
  null
  
)

export default component.exports